import React from "react";
const SaveChanges = ({ buttonName, onClick }) => {
  return (
    <div>
      <button
        className="flex mt-8 p-5 bg-[#FF6B00] md:flex md:ml-0 lg:ml-0 ml-10 tc1:ml-5 hover:bg-orange-200 text-[#FFFFFF] font-bold py-3 md:px-8 lg:px-8 px-20 rounded-lg whitespace-nowrap"
        onClick={onClick}
      >
        {buttonName}
      </button>
    </div>
  );
};
export default SaveChanges;
